/**
 * @architecture-header 1
 * @layer module-infrastructure
 * @domain settings-preferences
 * @responsibility Serialize the SET-F03 preferences-update wire command and response.
 * @state-owner authenticated API
 * @allowed-imports API client public type; @vispo/contracts
 * @forbidden React; UI role inference; name/avatar fields
 * @public-api updatePreferences
 * @side-effects authenticated HTTP request
 * @tests frontend/packages/workspace-web/src/modules/settings-preferences/components/PreferencesSurface.test.tsx
 * @naming-hook GET -> use<Resource> (no verb); POST create -> useCreate<Resource>; action sub-resource -> use<Action><Resource>
 * @naming-hook PUT/PATCH entity -> useUpdate<Resource>; DELETE -> useDelete<Resource>
 * @naming-hook banned prefixes: useGet, useFetch, useLoad, useSet, useRemove, useSave, useDo
 * @naming-path plural lowercase nouns; /me for the caller; no version, role or verb segment; filters in the query string
 * @naming-body camelCase; never the caller's role and never a server-side key — the token says who, the path says what
 */

import type { VispoApiClient } from '@vispo/api-client';
import {
  type UpdatePreferencesInput,
  updatePreferencesInputSchema,
  updatePreferencesResponseSchema,
} from '@vispo/contracts';

export function updatePreferences(apiClient: VispoApiClient, input: UpdatePreferencesInput) {
  return apiClient
    .request<unknown>('/api/v1/me/preferences', {
      method: 'PATCH',
      body: updatePreferencesInputSchema.parse(input),
    })
    .then((response) => updatePreferencesResponseSchema.parse(response));
}
